<template>
  <div class="container">
    <HomeHeader />
    <div class="content-tabs">
      <van-tabs
        title-inactive-color="#888888"
        title-active-color="#008cd6"
        color="#008cd6"
        background="$white"
        v-model:active="active"
        sticky
        animated
        @click-tab="onClickTab"
        @scroll="onScroll"
      >
        <van-tab
          v-for="(tab, index) in tabsArray"
          :title="tab.describe"
          :name="tab.type"
          :key="index"
        >
          <template #title>
            <div class="slot-title">{{ tab.describe }}</div>
          </template>
          <template #default>
            <NumList v-if="tab.type == 'numlist'" />
            <RankList v-if="tab.type == 'ranklist'" />
            <StatementPage v-if="tab.type == 'rule'" />
          </template>
        </van-tab>
      </van-tabs>
    </div>
    <div class="bottom-btn-pos" v-show="active == 'numlist'"><VoteBtn /></div>
    <img
      v-if="showBtn"
      class="serviceIcon"
      src="../assets/img/btn1.jpg"
      :class="fadeCss"
      @click="goToCs"
    />
    <Statement />
  </div>
</template>

<script>
import { Tab, Tabs } from "vant";
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Statement from "@/components/Statement.vue";
import NumList from "@/components/NumList.vue";
import RankList from "@/components/RankList.vue";
import StatementPage from "@/components/StatementPage.vue";
import HomeHeader from "@/components/HomeHeader.vue";
import useShare from "@/plugins/useShare.js";
import VoteBtn from "@/components/VoteBtn.vue";
import {
  useRouter,
  useRoute,
  // onBeforeRouteLeave,
  // onBeforeRouteUpdate,
} from "vue-router";

export default {
  name: "Home",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Statement,
    HomeHeader,
    VoteBtn,
    NumList,
    RankList,
    StatementPage,
  },
  setup() {
    const loading = ref(false);
    const finished = ref(false);
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const showBtn = ref(true);
    const fadeCss = ref("fadeIn");
    const lastScrollNumber = ref(0);
    const tabsArray = ref([]);
    // onBeforeRouteUpdate((to, from) => {
    //   //  当前组件路由改变后，进行触发
    //   console.log("update");
    // });
    // onBeforeRouteLeave((to, from) => {
    //   //  离开当前的组件，触发
    //   console.log("leave");
    // });

    console.log(router, route);
    if (route.query.id) {
      console.log("6有没有id", store.state.termId);
      store.state.termId = Number(route.query.id);
      let params = {
        term_id: store.state.termId,
      };
      store.dispatch("getAppEnv", { params }).then(() => {
        updateMenu();
        store.dispatch("getCanVote", { params });
        store.dispatch("getCandidates", { params, loading, finished });
      });
    } else {
      store.dispatch("getAppEnv", {}).then(() => {
        updateMenu();
      });
    }

    onMounted(() => {
      useShare();
    });
    // if (route.query.id) store.state.termId = Number(route.query.id);
    // console.log("4有没有id", store.state.termId);

    const updateMenu = () => {
      if (store.state.countDown > 0) {
        tabsArray.value = [
          // {
          //   describe: "编号排序",
          //   type: "awardPage",
          // },
          {
            describe: "编号排序",
            type: "numlist",
          },
          {
            describe: "排行榜",
            type: "ranklist",
          },
          {
            describe: "投票规则",
            type: "rule",
          },
        ];
      } else {
        tabsArray.value = [
          {
            describe: "编号排序",
            type: "numlist",
          },
          {
            describe: "排行榜",
            type: "ranklist",
          },
        ];
      }
    };
    const onClickTab = ({ name }) => {
      console.log("click有没有id", store.state.termId);
      let id = store.state.termId;
      if (name === "ranklist") {
        const params = { term_id: id };
        store.dispatch("getRank", { params });
      } else if (name === "numlist") {
        const params = { term_id: id };
        store.dispatch("getCandidates", { params, loading, finished });
        // store.dispatch("getLeftVote");
      }
    };

    const goToCs = () => {
      window.location.href = "https://zsrbactivity.zsnews.cn/vue/week/#";
    };

    const onScroll = (scroll) => {
      if (scroll.scrollTop > lastScrollNumber.value) {
        fadeCss.value = "fadeOut";
        setTimeout(() => {
          showBtn.value = false;
        }, 600);
      } else {
        setTimeout(() => {
          fadeCss.value = "fadeIn";
          showBtn.value = true;
        }, 600);
      }
      lastScrollNumber.value = scroll.scrollTop;
    };

    return {
      onClickTab,
      goToCs,
      onScroll,
      leftVoteNum: computed(() => store.state.leftVoteNum),
      showBtn,
      fadeCss,
      lastScrollNumber,
      tabsArray,
      updateMenu,
    };
  },
  data() {
    return {
      sessionToken: "eee",
      active: "numlist",
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: $light-gray;
}

.content-tabs {
  // padding-top: 10px;
  .slot-title {
    font-weight: 600;
    font-size: 16px;
    height: 24px;
    display: inline-block;
    line-height: 22px;
  }
}
.bottom-btn-pos {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom);
}

.serviceIcon {
  width: 55px;
  height: 55px;
  // background: linear-gradient(to right, #608ef4, #314fe5);
  box-shadow: 2px 2px 5px 1px #a09c9c;
  background: #ffffff;
  // padding: 4px;
  border-radius: 50%;
  position: fixed;
  bottom: 130px;
  right: 10px;
  z-index: 99;
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-iteration-count: 1;
}
.fadeOut {
  animation-name: fadeOut;
  animation-duration: 1s;
  animation-iteration-count: 1;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
</style>
